import {
  Cached,
  Mapper,
  VersionMapper,
  FirestoreEntity,
  getFirestoreEntityVersionFn,
  ChainedMapper,
} from '../@harmony';
import { FeedItem } from './domain/models/feed-item.model';
import {
  FeedItemDto,
  FeedItemEntity,
  AnyFeedItemEntityVersion,
} from './data/entities/feed-item.entity';
import {
  FeedItemDtoToFeedItemEntityMapper,
  FeedItemEntityToFeedItemMapper,
} from './domain/mappers/feed-item.mapper';

export abstract class FeedCommonProvider {
  abstract provideFeedItemEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyFeedItemEntityVersion>,
    FirestoreEntity<FeedItemEntity>
  >;
  abstract provideFeedItemDtoToFeedItemMapper(): Mapper<FeedItemDto, FeedItem>;
}

export class FeedCommonDefaultProvider implements FeedCommonProvider {
  @Cached()
  public provideFeedItemEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyFeedItemEntityVersion>,
    FirestoreEntity<FeedItemEntity>
  > {
    return new VersionMapper(getFirestoreEntityVersionFn, []);
  }

  @Cached()
  public provideFeedItemDtoToFeedItemMapper(): Mapper<FeedItemDto, FeedItem> {
    return new ChainedMapper<[FeedItemDto, FirestoreEntity<FeedItemEntity>, FeedItem]>([
      new FeedItemDtoToFeedItemEntityMapper(),
      new FeedItemEntityToFeedItemMapper(),
    ]);
  }
}
